import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3d60a44f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-table" }
const _hoisted_2 = ["innerHTML"]

import { ref } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'px-table',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const rowStyle = ref({
  height: "32px",
  fontWeight: 500,
  color: "#0A0A0A",
  size: "14px",
  lineHeight: "20px",
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: props.data.rows,
      style: {"width":"100%"},
      "row-style": rowStyle.value,
      "header-row-class-name": "table-header-row",
      "header-cell-class-name": "table-header-cell",
      "show-summary": props.data.showFooter,
      "summary-method": props.data.footer
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.columns, (col, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (col.cell)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  prop: col.prop,
                  label: col.label,
                  width: col.width
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", {
                      innerHTML: col.cell(scope.row, scope.column, scope.$index)
                    }, null, 8, _hoisted_2)
                  ]),
                  _: 2
                }, 1032, ["prop", "label", "width"]))
              : (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  prop: col.prop,
                  label: col.label,
                  width: col.width
                }, null, 8, ["prop", "label", "width"]))
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "row-style", "show-summary", "summary-method"])
  ]))
}
}

})